import { firebaseApp } from "constant";
import { getAnalytics } from "firebase/analytics";
import { Fragment, useLayoutEffect } from "react";
import { ChildrenProps } from "types";

export default function FirebaseProvider({ children }: ChildrenProps) {
  useLayoutEffect(() => {
    getAnalytics(firebaseApp);
  }, []);
  return <Fragment>{children}</Fragment>;
}
